import React from 'react';

import { Box, Typography, Tooltip } from '@mui/material';

import { IImageThumbnailsProps } from 'src/features/annotation/domain/types';

const ImageThumbnails: React.FC<IImageThumbnailsProps> = ({
	images,
	selectedImageURL,
	onSelectImage,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 1,
				overflowY: 'auto',
				alignItems: 'center',
				height: '100%',
			}}
		>
			{images.map((asset) => (
				<Box
					key={asset.id}
					sx={{
						border:
							selectedImageURL === asset.url
								? '3px solid #BE3327'
								: '6px solid transparent',
						transition: 'border 0.2s ease',
						borderRadius: 1,
						cursor: 'pointer',
						width: '100%',
						height: '180px',
						mb: 1,
					}}
					onClick={() => onSelectImage(asset)}
				>
					<img
						src={asset.thumbnail_url}
						alt={asset.file_name}
						style={{
							width: '100%',
							height: '120px',
							display: 'block',
						}}
					/>
					<Tooltip title={asset.file_name}>
						<Typography
							variant='caption'
							sx={{
								p: 0.5,
								textAlign: 'center',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								display: 'block',
								width: '100%',
							}}
						>
							{asset.file_name}
						</Typography>
					</Tooltip>
				</Box>
			))}
		</Box>
	);
};

export default ImageThumbnails;
